<template>
    <div class="social-bulk-section">
        <dashboard-header></dashboard-header>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                <div class="bulk-add-wrapping">
                    <div class="panel-body">

                        <table id="data-table" class="table table-striped table-bordered nowrap" width="100%" >
                            <thead>
                                <tr>
                                    <th>Website</th>
                                    <th>Email to use</th>
                                    <th>Keyword</th>
                                    <th><input type="checkbox" v-model="selectAllState" @click="selectAll()" /> Create All Sites<br/></th>
                                </tr>
                            </thead>
                            <tbody v-if="!siteArray">
                              <tr class="odd gradeX">
                                <td colspan="4">Loading API</td>
                              </tr>
                            </tbody>
                            
                            <tbody v-if="siteArray">
                                <tr class="odd gradeX" v-for="item in siteArray" :key="item.site">
                                    <td>{{item.site}}</td>
                                    <td>
                                        <select id="emails-social" v-model="item.email">
                                            <option v-for="acct in availableAccts" v-bind:value="acct.email">{{acct.email}}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select id="keywords-social" v-model="item.keyword">
                                            <option disabled value="">Please select one</option>
                                            <option v-for="keyword in availableKeywords" v-bind:value="keyword">{{keyword}}</option>
                                        </select>
                                    </td>
                                    
                                    <td><input type="checkbox" name="name1" v-model="item.isChecked"/></td>
                                </tr>
                                <tr v-if="siteArray.length >= 1" class="odd gradeX">
                                    <td>Total Sites to Create: <b>{{ siteCount }}</b></td>
                                    <td>Emails used: {{ uniqueEmails }}</td>
                                    <td>
                                        <label>Days Between Creation</label>
                                        <select v-model="creationBuffer">
                                        <option disabled value="">Please select one</option>
                                        <option>1</option>
                                        <option>2</option>
                                        <option>3</option>
                                        <option>4</option>
                                        </select>
                                    </td>
                                    
                                </tr>
                                
                                
                                
                            </tbody>
                        </table>
                        <input @click="addSites()" v-show="sitesSelected()" type="submit" class="btn-full btn btn-primary" value="Submit" >
                        <div v-show="savingEntries">Saving...</div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        
        
        
    </div>
</template>

<script>
    import moment from 'moment'
    import shuffle from "../util/shuffle";
    import { Usernames } from "../util/usernames";
    import WebLLCRESTApi from "../api/api";
    
    import DashboardHeader from "./DashboardHeader.vue";
    import DashboardFooter from "./DashboardFooter.vue";
    
    
    export default {
        async created() {
            var clientApi = new WebLLCRESTApi("Clients");
            var accountApi = new WebLLCRESTApi("Client-Accounts");
            
            var res = await Promise.all([
              accountApi.getData(null, { where: { "clientId": this.$route.params.id } }),
              clientApi.getData(this.$route.params.id)
            ]);
            
            this.availableAccts = res[0];
            this.availableKeywords = JSON.parse(res[1].keywords);
        
            this.siteArray = this.sites.map((site) => {
                return {
                    site: site,
                    email: (this.availableAccts.length > 0 ? this.availableAccts[0].email : ""),
                    isChecked: false,
                    keyword: '',
                    creationDate: null
                };
            });
        },
        
        data: function(){
            return {
                selectAllState: false,
                savingEntries: false,
                creationBuffer: '',
                
                availableAccts: [],
                availableKeywords: [],
                
                sites: [
                  "crunchbase",
                  "minds",
                  "muckrack",
                  "readthedocs",
                  "startus",
                  "triberr"
                ],
                
                siteArray: null
            
            }
        },
        
        computed: {
            siteCount() {
                return this.siteArray.filter((x) => {
                    return x.isChecked;
                }).length
            },
            
            uniqueEmails() {
                return this.siteArray.filter((site) => {
                    return site.isChecked;
                }).map(item => {
                    return item.email;
                }).filter((email,index, emailArr) => {
                    return emailArr.indexOf(email) == index;   
                }).join(", ");
            }
        },
        
        methods: {
            selectAll() {
                this.siteArray.map(i => {
                    i.isChecked = !this.selectAllState;
                })
            },
            
            sitesSelected() {
                return (this.creationBuffer > 0 && this.siteCount > 0);
            },
            
            async addSites() {
                var api = new WebLLCRESTApi("Social-Profiles");
                
                // get the sites we need to add
                var sitesToAdd = this.siteArray.filter(i => i.isChecked);
                
                // shuffle them so they aren't always created in the same order
                shuffle(sitesToAdd);
                
                // add creation dates to every item
                var sitesWithCreateTime = sitesToAdd.map((site, index) => {
                    var createMoment = moment();
                    createMoment.add(index * parseInt(this.creationBuffer), 'days');
                    
                    var usernames = Usernames.getPossibleUsernames(site.keyword);
                    
                    return {
                      "site": site.site,
                      "email": site.email,
                      "username": usernames[0],
                      "keyword": site.keyword,
                      "password": this.generatePassword(10),
                      "url": "",
                      "content": "",
                      "error": false,
                      "created": false,
                      "onlyCreateAfter": createMoment.toISOString(),
                      "clientId": this.$route.params.id
                    };
                });
                
                // append all new entries to the api
                this.savingEntries = true;
                
                await Promise.all(sitesWithCreateTime.map((site) => {
                    return api.addData(site);
                }));
                
                this.savingEntries = false;
                
                this.$router.push('/client/' + this.$route.params.id);
            },
            
            generatePassword(pwdLen) {
              var pwdChars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!$@#";
              return Array(pwdLen).fill(pwdChars).map(function(x) { return pwdChars[Math.floor(Math.random() * pwdChars.length)] }).join('');
            }
        },
        components: {
            DashboardHeader,
            DashboardFooter,
            
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/SocialAdd.vue